/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TestDetectionRuleMatch,
  TestDetectionRuleMatch$inboundSchema,
} from "./testdetectionrulematch.js";

export type TestDetectionRuleResult = {
  /**
   * Matches the rule found in the sample.
   */
  matches: Array<TestDetectionRuleMatch>;
  /**
   * Why the rule isn't supported when `supported` is false.
   */
  reason?: string | undefined;
  /**
   * False when the rule has no text-only detector (e.g. `shadow_mcp`, `destructive_tool`).
   */
  supported: boolean;
};

/** @internal */
export const TestDetectionRuleResult$inboundSchema: z.ZodMiniType<
  TestDetectionRuleResult,
  unknown
> = z.object({
  matches: z.array(TestDetectionRuleMatch$inboundSchema),
  reason: z.optional(z.string()),
  supported: z.boolean(),
});

export function testDetectionRuleResultFromJSON(
  jsonString: string,
): SafeParseResult<TestDetectionRuleResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TestDetectionRuleResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TestDetectionRuleResult' from JSON`,
  );
}
